import { Component, Input, OnInit, OnChanges } from "@angular/core";
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";

@Component({
    selector: "app-data-visibility",
    templateUrl: "./data-visibility.component.html",
    styleUrls: ["./data-visibility.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class DataVisibilityComponent implements OnInit, OnChanges {
  @Input() currentDataFields!: any;
  @Input() visibleDataPoints!: any;
  @Input() chartType!: any;
  @Input() chartData!: any;
  childForm: any;
  public fieldForm!: UntypedFormGroup;
  public aggregateData: any = [];
  visibleData: any[] = [];

  constructor(
    public parentF: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private canvasService: CanvasService,
    public commonService: CommonService,
    public dialog: MatDialog
  ) {}

  get grouplist(): UntypedFormArray {
    return this.fieldForm.get("groupby") as UntypedFormArray;
  }

  isOptionDisabled(opt: any): boolean {
    return (
      this.fieldForm.get("fields")!.value.length >= 1 &&
      !this.fieldForm.get("fields")!.value.find((el: any) => el == opt)
    );
  }

  buildAggregateData(event: any) {
    //TODO darrin possible fix
    const visibleDataPointIds = this.fieldForm.get("fields")!.value;
    const appliedSeries: any = [];
    let data: any;
    visibleDataPointIds.forEach((element: any) => {
      data = {
        dataPointId: element,
        breakDownDataPointId: null,
      };
      appliedSeries.push(data);
    });

    this.childForm.get("visibleDataPointIds")!.setValue(appliedSeries);

    // make refresh call and emit the chart data to the parent
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        this.canvasService.populateCanvas(data);
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        this.canvasService.populateCanvas(data);
      }
    );
  }

  initForm() {
    this.fieldForm = this.fb.group({
      fields: new UntypedFormControl([]),
    });
  }
  populateVisibleList() {
    // TODO DARRIN POSSIBLE NEEDS TO CHANGE
    this.visibleData = this.commonService.generateVisualDataPoints(
      this.visibleDataPoints
    );

    this.fieldForm.get("fields")!.setValue(this.visibleData);
    if (this.childForm) {
      //     this.childForm.get("visibleDataPointIds")!.setValue(this.visibleData);
    }
  }

  ngOnChanges() {
    if (this.fieldForm) {
      this.populateVisibleList();
    }
  }

  ngOnInit(): void {
    this.childForm = this.parentF.form;
    this.initForm();
    this.populateVisibleList();
  }
}
